import React from "react";
import TaxMappingList from "./TaxMappingList.tsx";
import TaxMappingFilters from "./TaxMappingFilters.tsx";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { observer } from "mobx-react-lite";
import { Link, Outlet } from "react-router-dom";

const TaxMappingDashboard: React.FC = () => {
  return (
    <div>
      <h1>Tax Mappings</h1>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <TaxMappingFilters />
        <Button
          component={Link}
          to="create"
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ alignSelf: "baseline" }}
        >
          Add new
        </Button>
      </Box>
      <TaxMappingList />
      <Outlet />
    </div>
  );
};

export default observer(TaxMappingDashboard);
